(function(){
  'use strict';
  function setupNav(root){
    var nav=root.querySelector('[data-akbisac-nav-links]');
    var button=root.querySelector('[data-akbisac-expand]');
    if(!nav || !button)return;
    function update(){
      var expanded=nav.classList.contains('is-expanded');
      if(!expanded){
        button.hidden=false;
        button.hidden=nav.scrollHeight <= nav.clientHeight+2;
      }
      button.setAttribute('aria-expanded',expanded?'true':'false');
      button.innerHTML=expanded?'Show fewer categories <span aria-hidden="true">↑</span>':'Show all categories <span aria-hidden="true">→</span>';
    }
    if(!button.dataset.akbisacBound){
      button.dataset.akbisacBound='1';
      button.addEventListener('click',function(){nav.classList.toggle('is-expanded');update();});
    }
    update();
  }
  function setupDescription(root){
    var desc=root.querySelector('[data-akbisac-description]');
    var button=root.querySelector('[data-akbisac-read-more]');
    if(!desc || !button)return;
    var expanded=desc.classList.contains('is-expanded');
    if(!expanded){
      button.hidden=desc.scrollHeight<=desc.clientHeight+3;
    }else{button.hidden=false;}
    button.setAttribute('aria-expanded',expanded?'true':'false');
    button.innerHTML=expanded?'Read less <span aria-hidden="true">↑</span>':'Read more <span aria-hidden="true">↓</span>';
    if(!button.dataset.akbisacBound){
      button.dataset.akbisacBound='1';
      button.addEventListener('click',function(){
        desc.classList.toggle('is-expanded');
        setupDescription(root);
      });
    }
  }
  function setupShelf(section){
    var track=section.querySelector('[data-akbisac-track]');
    if(!track)return;
    var left=section.querySelector('[data-akbisac-prev]');
    var right=section.querySelector('[data-akbisac-next]');
    var designMode=document.documentElement.classList.contains('shopify-design-mode');
    // Scrolling changes only arrow state. It must NOT rebuild the layout:
    // toggling grid/flex during scrolling can shift carousel card sizes.
    function updateArrows(){
      var overflow=track.scrollWidth>track.clientWidth+3;
      if(left){left.hidden=!overflow;left.disabled=track.scrollLeft<=2;}
      if(right){right.hidden=!overflow;right.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-3;}
    }
    function updateLayout(){
      // Stable flex track only. Earlier grid/flex mode switching could produce
      // unequal cards depending on product count and computed image widths.
      var books=Array.prototype.slice.call(track.querySelectorAll('[data-akbisac-book]:not([hidden])'));
      var count=books.length;
      section.hidden=count<3 && !designMode;
      track.classList.remove('is-fill-row','is-short-shelf');
      track.style.removeProperty('--akbisac-fill-count');
      track.style.removeProperty('grid-template-columns');
      track.style.removeProperty('display');
      track.removeAttribute('data-fill-count');
      track.setAttribute('data-akbisac-layout-version','stable-flex-03nov-v3');
      track.setAttribute('data-akbisac-visible-count',String(count));
      track.querySelectorAll('.is-fill-first,.is-fill-last').forEach(function(el){
        el.classList.remove('is-fill-first','is-fill-last');
      });
      if(count>=3){
        var capacity=parseInt(window.getComputedStyle(track).getPropertyValue('--akbisac-visible-columns'),10)||7;
        // Center undersized rails, but NEVER stretch or change card geometry.
        if(count<capacity)track.classList.add('is-short-shelf');
      }
      updateArrows();
    }
    if(!track.dataset.akbisacBound){
      track.dataset.akbisacBound='1';
      left&&left.addEventListener('click',function(){track.scrollBy({left:-Math.max(track.clientWidth*.85,200),behavior:'smooth'});});
      right&&right.addEventListener('click',function(){track.scrollBy({left:Math.max(track.clientWidth*.85,200),behavior:'smooth'});});
      track.addEventListener('scroll',updateArrows,{passive:true});
    }
    updateLayout();
  }
  function bookKey(el){
    var family=(el.getAttribute('data-book-family')||'').trim().toLowerCase();
    if(family)return 'family:'+family;
    var title=(el.getAttribute('data-book-title')||'').trim().toLowerCase().replace(/\s+/g,' ');
    if(title)return 'title:'+title;
    return 'id:'+(el.getAttribute('data-book-id')||'');
  }
  function removeRepeatedMerchandise(){
    var used=new Set();
    /* The featured product takes priority; the AJAX catalog is untouched.
       A shelf with fewer than three unique visible titles is suppressed and
       does NOT reserve those titles against later viable shelves. */
    document.querySelectorAll('[data-akbisac-feature]').forEach(function(el){used.add(bookKey(el));});
    document.querySelectorAll('[data-akbisac-shelf]').forEach(function(section){
      var uniqueKeys=[];
      section.querySelectorAll('[data-akbisac-book]').forEach(function(el){
        var key=bookKey(el);
        if(used.has(key)){el.hidden=true;}
        else{el.hidden=false;used.add(key);uniqueKeys.push(key);}
      });
      if(uniqueKeys.length<3){
        uniqueKeys.forEach(function(key){used.delete(key);});
      }
    });
  }
  function init(scope){
    removeRepeatedMerchandise();
    (scope||document).querySelectorAll('[data-akbisac-intro]').forEach(setupDescription);
    (scope||document).querySelectorAll('[data-akbisac-navigation]').forEach(setupNav);
    (scope||document).querySelectorAll('[data-akbisac-shelf]').forEach(setupShelf);
  }
  /* Event delegation survives XCloud AJAX re-rendering of the result grid. */
  function ajaxCartSubmit(event){
    var form=event.target;
    if(!form || !form.matches || !form.matches('.akbisac-quick-form, .akbisac-catalog .albaki-book-card__cart-form'))return;
    var button=form.querySelector('button[type="submit"]');
    var variant=form.querySelector('input[name="id"]');
    if(!variant || !variant.value || (button && button.disabled)){return;}
    if(!window.fetch || !window.FormData){return;} // Native cart POST fallback.
    event.preventDefault();
    var notification=document.querySelector('cart-notification');
    var drawer=document.querySelector('cart-drawer');
    var cartUI=drawer || notification;
    var formData=new FormData(form);
    if(cartUI && typeof cartUI.getSectionsToRender==='function'){
      formData.append('sections',cartUI.getSectionsToRender().map(function(section){return section.id;}).join(','));
      formData.append('sections_url',window.location.pathname);
    }else{
      formData.append('sections','cart-icon-bubble');
    }
    var previousText=button?button.textContent:'';
    var error=form.querySelector('.akbisac-cart-error');
    if(error)error.remove();
    if(button){button.disabled=true;button.textContent='Adding…';}
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js',{
      method:'POST',body:formData,headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}
    }).then(function(response){
      return response.json().then(function(data){if(!response.ok || data.status){throw new Error(data.description || data.message || 'Could not add this book.');}return data;});
    }).then(function(data){
      if(cartUI && data.sections && typeof cartUI.renderContents==='function'){
        try{cartUI.renderContents(data);}catch(err){window.location.assign('/cart');}
      }else if(data.sections && data.sections['cart-icon-bubble']){
        var icon=document.getElementById('cart-icon-bubble');
        var doc=new DOMParser().parseFromString(data.sections['cart-icon-bubble'],'text/html');
        var updated=doc.getElementById('cart-icon-bubble');
        if(icon && updated)icon.innerHTML=updated.innerHTML;
      }
      if(!cartUI){form.dispatchEvent(new CustomEvent('akbisac:cart-added',{bubbles:true,detail:data}));}
    }).catch(function(err){
      var msg=document.createElement('div');msg.className='akbisac-cart-error';msg.setAttribute('role','alert');msg.textContent=err.message || 'Unable to add to cart.';form.appendChild(msg);
    }).finally(function(){if(button){button.disabled=false;button.textContent=previousText;}});
  }
  /* Keep the collection URL unchanged: intercept only this BISAC shortcut.
     Normal filter selections, sorting and pagination remain owned by XCloud. */
  document.addEventListener('click',function(event){
    var source=event.target && event.target.closest && event.target.closest('[data-akbisac-filter-jump]');
    if(!source || event.defaultPrevented || event.button!==0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)return;
    var catalog=document.getElementById('albaki-catalog');
    if(!catalog)return; // Leave the native anchor fallback in place.
    event.preventDefault();
    var reduced=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    catalog.scrollIntoView({behavior:reduced?'auto':'smooth',block:'start'});
  });
  document.addEventListener('submit',ajaxCartSubmit);
  document.addEventListener('DOMContentLoaded',function(){init(document);});
  document.addEventListener('shopify:section:load',function(){init(document);});
  window.addEventListener('load',function(){init(document);});
  window.addEventListener('resize',function(){init(document);});
  if(document.readyState!=='loading')init(document);
})();
